export const GET_HEARTLAND_CONFIG_REQUESTED = 'brand/GET_HEARTLAND_CONFIG_REQUESTED';
export const GET_HEARTLAND_CONFIG_SUCCESS = 'brand/GET_HEARTLAND_CONFIG_SUCCESS';
export const GET_HEARTLAND_CONFIG_FAILURE = 'brand/GET_HEARTLAND_CONFIG_FAILURE';

export const UPDATE_HEARTLAND_CONFIG_REQUESTED = 'brand/UPDATE_HEARTLAND_CONFIG_REQUESTED';
export const UPDATE_HEARTLAND_CONFIG_SUCCESS = 'brand/UPDATE_HEARTLAND_CONFIG_SUCCESS';
export const UPDATE_HEARTLAND_CONFIG_FAILURE = 'brand/UPDATE_HEARTLAND_CONFIG_FAILURE';

const initialState = {
  loading: false,
  loaded: false,
  error: false,
  heartlandList: [],
};

export default(state = initialState, action) => {
  switch (action.type) {
    case GET_HEARTLAND_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        heartlandList: [],
      };
    }
    case GET_HEARTLAND_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        heartlandList: action.result,
      };
    }
    case GET_HEARTLAND_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }
    case UPDATE_HEARTLAND_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case UPDATE_HEARTLAND_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
      };
    }
    case UPDATE_HEARTLAND_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
};

export const getHeartlandConfig = (brandId) => {
  return {
    types: [GET_HEARTLAND_CONFIG_REQUESTED, GET_HEARTLAND_CONFIG_SUCCESS, GET_HEARTLAND_CONFIG_FAILURE],
    promise: client => client.get(`getHeartlandConfig/${brandId}`)
  };
};

export const postHeartlandConfig = (brandId, data) => {
  return {
    types: [UPDATE_HEARTLAND_CONFIG_REQUESTED, UPDATE_HEARTLAND_CONFIG_SUCCESS, UPDATE_HEARTLAND_CONFIG_FAILURE],
    promise: client => client.post(`postHeartlandConfig/${brandId}`, { data })
  };
};
